import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import clsx from 'clsx';
import styles from './Popup.module.scss';

const Popup = ({ isOpen, onClose, children, className }) => {
  useEffect(() => {
    if (!isOpen) return;
    const y = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.top = `-${y}px`;
    document.body.style.overflow = 'hidden';
    return () => {
      const scrollY = parseInt(document.body.style.top || '0', 10) * -1;
      document.body.style = '';
      window.scrollTo(0, scrollY);
    };
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const portalTarget =
    document.getElementById('popup-portal') || document.body;

  return createPortal(
    <div className={styles.overlay} onClick={onClose}>
      <div
        className={clsx(styles.modal, className)}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className={styles.close}
          onClick={onClose}
          aria-label="Закрыть"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path d="M6 6L18 18" stroke="#0A0A0A" strokeWidth="2" />
            <path d="M6 18L18 6" stroke="#0A0A0A" strokeWidth="2" />
          </svg>
        </button>
        <div className={styles.content}>{children}</div>
      </div>
    </div>,
    portalTarget
  );
};

export default Popup;
